import Image from "next/image";

export default function CopernicusBadge({ size = 20 }) {
    const iconSize = size;
  return (
    <div className="flex flex-col justify-center items-center gap-1 mt-5">
        <p className="text-sm text-gray-500">Colaborador en el programa Copernicus.</p>
      <Image
        src="/copernicus.ico"
        alt="Copernicus"
        width={iconSize}
        height={iconSize}
      />
      </div>
    );
  };